export function transformColumnNamesToProperties(selectedColumns: string[]): string[] {
  const result: string[] = [];
  for (const c of selectedColumns) {
    result.push(c.substring(c.lastIndexOf('.') + 1));
  }
  return result;
}
